import { createSlice } from "@reduxjs/toolkit";
import { getWorkTypeList,getWorkTypeByID } from "./worktypeAction";

const worktypeSlice = createSlice({
    name: "worktype",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,        
        unitsLoading: false,
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        worktypelist: [],
        worktypeParams: {
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },
        
    },
    reducers: {
       
        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },   
        SetWorkTypeParams: (state, action) => {
            return {
                ...state,
                worktypeParams: {
                    ...state.worktypeParams,
                    ...action.payload
                },
            };
        },
        isModelVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWorkTypeList.pending, (state, action) => {
                state.status = "getWorkTypeList loading";
                state.loading = true;
            })
            .addCase(getWorkTypeList.fulfilled, (state, action) => {
                console.log(action.payload.response)
                state.status = "getWorkTypeList succeeded";
                state.loading = false;
                var response = action.payload.response;
                var noofpages = Math.ceil(
                    action.payload.count / state.worktypeParams?.page_size
                );

                state.worktypelist = response.results;
                state.listCount = response.count;
                state.worktypeParams = {
                    ...state.worktypeParams,
                    no_of_pages: noofpages,
                };
            })
            .addCase(getWorkTypeList.rejected, (state, action) => {
                state.status = "getWorkTypeList failed";
                state.loading = false;
                state.error = action.error.message;
            })
            
            .addCase(getWorkTypeByID.pending, (state, action) => {
                state.status = "getWorkTypeByID loading";
                state.loading = true;
            })
            .addCase(getWorkTypeByID.fulfilled, (state, action) => {
                state.status = "getWorkTypeByID succeeded";
                state.loading = false
                state.rowdata = action.payload;
            }
            )
            .addCase(getWorkTypeByID.rejected, (state, action) => {
                state.status = "getWorkTypeByID failed";
                state.loading = false;
                state.error = action.error.message;
            })
           
    }

});
export const {
    InputChangeValue,
    SetWorkTypeParams,
    isModelVisible
} = worktypeSlice.actions;

export default worktypeSlice.reducer;